<template>
    <div>
        <section-hosts-landing/>

        <section-programme/>

        <section-wedding-menu/>

        <base-section header="Místo svatby">
            <p class="text-xs-center">Zámek Třebušín</p>
            <text-striked>Praktické informace</text-striked>
            <div class="text-xs-center">
                <p>Předsvatební hostina, obřad, párty a přespání, to vše bude probíhat na jednom místě, na zámku v Třebušíně.</p>
                <p>
                    Po příjezdu pro Vás budou připraveny zámecké pokojíčky po dvou až třech lidech, které Vám budou k dispozici po celou dobu svatby.
                    Hostina bude probíhat uvnitř, u společného stolu, ale pokud to počasí dovolí, budeme chtít maximálně využít zámecké zahrady, kde se pod 400letým bukem vezmeme.
                    Zámek disponuje i prostorným barem, kde z píp po celý den i noc poteče Plzeň a Birell pomelo & grep.
                </p>
            </div>
            <text-striked>Historie Zámku</text-striked>
            <p class="text-xs-center">
                Historie obce Třebušín sahá až do dvanáctého století, kdy přibližně na území zámku stála středověká tvrz.
                Ta byla za husitských válek vypálena Janem Žižkou, který si nad Třebušínem postavil vlastní hrad Kalich (jeho zbytky si prohlédneme v neděli).
                Pravděpodobně ve druhé polovině 16. století Oldřich či Tristan Hostakovští postavili při dvoře malou renesanční tvrz o dvou křídlech do pravého úhlu.
                Nejvýznamnějším majitelem třebušínského panství byl bezesporu poslední člen rodu Kresslů, osvícenec František Karel, který se stal prvním ředitelem právnické fakulty v Praze.
                Někdy okolo roku 1710 započal přestavbu třebušínské tvrze na barokní zámek. Jejím autorem byl pravděpodobně litoměřický stavitel Octavio Broggio.
                Z této doby se v přízemí severního křídla zachovaly lunetové a křížové klenby s hřebínky. Od počátku 20. století zámek patřil předkům současné majitelky,
                v roce 1945 však byly rodinné statky včetně zámku znárodněny na základě Benešových dekretů a majitelé vyhnáni ze země.
                Ze zámku se stala škola, přičemž byla zničena barokní štuková výzdoba v pokojích. Dcera původních majitelů po revoluci zámek znovu odkoupila, nějaký čas byl provozován jako hotel.
                Dnes sice zámek ani zahrada nevypadají jako za dob své největší slávy, nadšení nájemnci však dělají vše, aby to změnili.
            </p>
        </base-section>

        <section-gifts/>


        <base-section header="Jak se obléknout?">
            <p class="text-xs-center">
                Oblečte se do něčeho, v čem se cítíte dobře. Nehodláme se potit ve vznešených róbách, běžecké oblečení však protentokrát necháme doma.
                Většinu dne budeme pravděpodobně trávit v zahradě. Obřad se bude konat venku za každého počasí, proto pokud se bojíte kapek deště, přibalte si deštník.
                Nezapomeňte pohodlné botky pro nedělní výšlap na Kalich.
            </p>
        </base-section>

        <section-transport/>
    </div>
</template>

<script>
    import BaseSection from "@/components/BaseSection";
    import SectionProgramme from "@/components/SectionProgramme";
    import SectionGifts from "@/components/SectionGifts";
    import TextStriked from "@/components/TextStriked";
    import SectionHostsLanding from "@/components/SectionHostsLanding";
    import SectionWeddingMenu from "@/pages/SectionWeddingMenu";
    import SectionTransport from "@/components/SectionTransport";

    export default {
        name: "HostsPage",
        components: {
            SectionTransport,
            SectionWeddingMenu,
            SectionHostsLanding,
            SectionGifts,
            SectionProgramme,
            TextStriked,
            BaseSection
        },

    }
</script>
